"use client";
import React from "react";
import { CustomerProfileHeader } from "@/components/customerProfile/customerProfileHeader";
import { VerifyEmailHeader } from "@/components/verifyEmail/verifyEmailHeader";
import { CheckoutHeader } from "@/components/checkout/checkoutHeader";
import {
  ROUTE_CUSTOMER_PROFILE,
  ROUTE_VERIFY_EMAIL,
  ROUTE_CHECKOUT,
  ROUTE_GUEST_CHECKOUT,
  ROUTE_CONFIRMATION,
} from "@/utils/constants";

export type HeaderRegistry = Record<
  string,
  (opts?: any) => React.ReactNode | null | undefined
>;

export const headerRegistry: HeaderRegistry = {
  [ROUTE_CUSTOMER_PROFILE]: () => <CustomerProfileHeader />,

  [ROUTE_VERIFY_EMAIL]: () => <VerifyEmailHeader />,

  [ROUTE_CHECKOUT]: ({ redirectToGiftCard, merchant } = {}) => (
    <CheckoutHeader
      redirectToGiftCard={redirectToGiftCard}
      isRunningTabsEnabled={merchant?.isRunningTabsEnabled}
    />
  ),

  [ROUTE_GUEST_CHECKOUT]: ({ redirectToGiftCard, merchant } = {}) => (
    <CheckoutHeader
      redirectToGiftCard={redirectToGiftCard}
      isRunningTabsEnabled={merchant?.isRunningTabsEnabled}
    />
  ),

  [ROUTE_CONFIRMATION]: ({ isScanToOrder } = {}) => {
    if (isScanToOrder) return null;
    return undefined; // undefined signals caller to use default fallback
  },
};
